import { axios } from '../../../../services/http/axios';

export const artHistory = {
    list: (searchParams) =>
        axios.get(`/stability/text-to-image/history?${searchParams.toString()}`).then((res) => res.data)
};
